import LandingPage from "../LandingPage.jsx";

export default function LandingUk() {
  return <LandingPage forcedLang="uk" />;
}